import { getModKeyState } from 'src/utils/KeyEventUtils';

export const useOSDetector = () => {
  const isMac = navigator.userAgent.includes('Mac');

  const isOSMetaKeyPressed = (ev: KeyboardEvent) => {
    if (isMac) {
      return getModKeyState(ev, 'Meta');
    }
    return getModKeyState(ev, 'Control');
  };

  return isOSMetaKeyPressed;
};
